/*
 * @Author: yexiu
 * @Date: 2024-12-09 10:58:30
 * @LastEditors: monai
 * @LastEditTime: 2025-07-23 14:16:57
 */
import LanguageTextCache from './getLangText_cacheClass';
import HTTP_Client from './getHttpClient';
import { getQueryString, fnColorLog, fnParamsCheck } from '@activity-business/h5-package-frameworkTool';

const getLangText: DevelopToolShare.GetLangText = async (app, parameter) => {
    // 默认使用接口文案
    const {useAjaxText, activityId, countryCode, reactText, reactActivityInfo, reactDomain} = parameter;
    if (useAjaxText) {
        // 参数校验、错误提示
        if (fnParamsCheck({countryCode})) return;
        // 文案缓存
        const languageCache = new LanguageTextCache(activityId, countryCode, reactText);
        const ENCRYPT = getQueryString('encrypt');
        if (!ENCRYPT) {
            fnColorLog(['developTool_Share', '已使用接口文案'], 'error', '参数获取失败,请添加加密串参数');
            throw new Error(`[${new Date().toLocaleString()}] developTool_Share 文案, 参数获取失败, 请添加加密串参数!`);
        }
        HTTP_Client(`/activity/center/web/h5/activity/share/decryptConfigs?secretValue=${ENCRYPT}`)
        .then(response => {
            const {data: { data, errorCode}} = response;
            if (errorCode != 0) throw response;
            const textArr: string[] = data.list.map(item => item.content);
            // 接口文案是否与当前是否的文案匹配
            if (!languageCache.matchCache(textArr)) {
                // 更新数据
                reactText.splice(0, reactText.length, ...textArr);
                fnColorLog(['developTool_Share', '已使用接口文案'], 'success', reactText);
            }
            // 更新数据
            languageCache.updateDate(textArr);
            /***** 其他信息处理 *****/
            reactActivityInfo.isEnd = data.isEnd;
            /***** 域名信息处理 *****/
            Object.assign(reactDomain, data.domain);
        })
        .catch(err => {
            console.log(`[${new Date().toLocaleString()}] - err`, err);
        });
    }
};

export default getLangText;